.productOption {
	display: flex;
	align-items: center;
	gap: 6px;
}

.productBadge {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	border-radius: 3px;
	font-size: 11px;
	font-weight: 600;
	line-height: 1;
}

.productBadgeGeneric {
	background: #dbeafe;
	color: #1d4ed8;
}

.productBadgeLabeled {
	background: #dcfce7;
	color: #15803d;
}
